import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {NavigationEnd, Router, RouterLink} from '@angular/router';
import {MatTooltip} from '@angular/material/tooltip';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatButton} from '@angular/material/button';
import {filter} from 'rxjs';
import { AuthService } from '@lib-ui/auth/auth.service';

interface IPage {
    link: string;
    name: string;
    icon: string;
}

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [
        MatIcon,
        RouterLink,
        MatTooltip,
        MatMenu,
        MatMenuItem,
        MatMenuTrigger,
        MatButton
    ],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss'
})
export class MenuComponent implements OnInit{
    @Input() isAuth = false;
    @Input() pageName = signal<string>('');
    @Output() logoutEvent = new EventEmitter();
    protected authService = inject(AuthService);
    activeUrl = '';
    navMenu = {
        pages: [
            {
                link:'',
                name: 'Главная',
                icon: 'home'
            },
            {
                link:'report',
                name: 'Отчетность',
                icon: 'report'
            },
            {
                link:'logs',
                name: 'Журнал изменений',
                icon: 'history'
            },
        ],

        directory: {
            name: 'Справочник',
            icon:'library_books',
            links: [
                {
                    link:'company',
                    name: 'Компании',
                    icon: 'store_mall_directory',
                    hide: !this.authService.isAdmin(),
                },
                {
                    link:'project',
                    name: 'Проекты',
                    icon: 'apps'
                },
                {
                    link:'group',
                    name: 'Группы',
                    icon: 'supervisor_account'
                },
                {
                    link:'category',
                    name: 'Категории',
                    icon: 'folder'
                },
                {
                    link:'work',
                    name: 'Виды работ',
                    icon: 'work'
                },
                {
                    link: 'item',
                    name: 'Оборудование',
                    icon: 'power'
                },
                {
                    link:'order',
                    name: 'Заявки',
                    icon: 'call'
                },
                {
                    link:'location',
                    name: 'Адреса',
                    icon: 'place'
                },
                {
                    link:'person',
                    name: 'Контакты',
                    icon: 'contacts'
                },
                {
                    link:'file',
                    name: 'Файлы',
                    icon: 'insert_drive_file'
                },
                {
                    link:'price-list',
                    name: 'Прайсы',
                    icon: 'euro_symbol'
                },
                {
                    link:'custom-fields',
                    name: 'Настраиваемые поля',
                    icon: 'settings_account_box'
                },
            ]
        }

    };

    constructor(private router: Router) {}

    ngOnInit(): void {

        // это надо не только для обновления страницы, но и редиректа при вводе несуществующего роута или вводе роута руками
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
            this.activeUrl = this.router.url.split('/')[1];
            let page: IPage | undefined = this.navMenu.pages.find(page => page.link === this.activeUrl);
            if (!page) {
                page = {
                    link:'',
                    name: '',
                    icon: ''
                };
            }
            const pageNameDirectory = this.navMenu.directory.links.find(link => link.link === this.activeUrl)?.name;
            const pageName =  page.link === this.activeUrl ? page.name : '';
            this.pageName.set(pageNameDirectory || pageName);
        });
    }

    logout(): void {
        this.logoutEvent.emit();
    }
}
